module.exports = __webpack_public_path__ + "img/stock.db0b0bb4.svg";